import { useRequestURL } from '#imports'

import type { Product } from '../models/product'

export function useProductPageLink({
  useClientSideNavigation,
}: {
  useClientSideNavigation: boolean
}) {
  const { origin } = useRequestURL()
  const buildProductPageLink = (product: Product) => {
    const url =
      product.productPageLink.name === 'master-pp'
        ? `/${product.productPageLink.params.locale}/p/${product.productPageLink.params.slug}`
        : `/${product.productPageLink.params.locale}/p/${product.productPageLink.params.slugV2}/${product.productPageLink.params.uuid}`

    return useClientSideNavigation ? url : `${origin}${url}`
  }

  return { buildProductPageLink }
}
